import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const getFiles = async (type: string) => {
  const response = await axios.get(`${getAPIService}/${type}`)
  return response.data
}
